export default __webpack_public_path__ + "static/media/379.fc264331.gif";